import { setEMAIL } from "../constants/email.types";

export const setEmail = (email: string) => {
  return {
    type: setEMAIL,
    payload: email,
  };
};
